export default `---
slug: usa
country: United States
countryCode: US1
continent: America
year: 2014
title: "United States — The Exchange Year"
description: "A full academic year in Ardmore, Oklahoma as a high school exchange student. Pickup basketball, AP classes, and my first real taste of America."
thumbnail: /images/travels/US1/usa_thumb.jpg
relatedLinks: []
---
![usa](/images/travels/US1/usa_thumb.jpg)

*Story coming soon — stay tuned!*

I visited United States and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
